import { Dialog, DialogActions, DialogTitle, DialogContent, Grid, Box, Autocomplete, TextField } from '@mui/material';
import * as React from 'react';
import {
    Button,
} from "@mui/material";
import { useState } from 'react';
import { IGreenhouse } from '../interfaces/IGreenhouse';
import { Controller, useForm, useFormContext } from 'react-hook-form';
import { IBay } from '../interfaces/IBay';
import { IZone } from '../interfaces/IZone';
import { IBench } from '../interfaces/IBench';
import axios from 'axios';
import { is } from 'immer/dist/internal';


type Props = {
    title: string,
    isOpen: boolean,
    source: IGreenhouse | IBay | IZone | IBench | undefined,
    sourceType: string,
    handleClose: () => void,
}

export default function MovementDialog(props: Props) {
    const { title, handleClose } = props;
    const [greenhouse, setGreenhouse] = useState<IGreenhouse>();
    const [bay, setBay] = useState<IBay>();
    const [zone, setZone] = useState<IZone>();
    const [bench, setBench] = useState<IBench>();
    const [greenhouses, setGreenhouses] = useState<Array<IGreenhouse>>([]);
    const [bays, setBays] = useState<Array<IBay>>([]);
    const [zones, setZones] = useState<Array<IZone>>([]);
    const [benches, setBenches] = useState<Array<IBench>>([]);

    React.useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_ENDPOINT}/api/Greenhouses`)
            .then(res => {
                setGreenhouses(res.data);
            });
    })

    React.useEffect(() => {
        if (greenhouse) {
            setBays(greenhouse.bays);
        } else {
            setBays([]);
        }
    }, [greenhouse])

    React.useEffect(() => {
        if (bay) {
            setZones(bay.zones);
        } else {
            setZones([]);
        }
    }, [bay])

    React.useEffect(() => {
        if (zone) {
            setBenches(zone.benches);
        } else {
            setBenches([]);
        }
    }, [zone])

    interface IFormInput {
        Greenhouse: IGreenhouse,
        Bay: IBay,
        Zone: IZone,
        Bench: IBench,
        Type: string
    }

    const onSubmit = (data: IFormInput) => {
        console.log("SUBMIT DATA", data);
        console.log(props.source);
        axios.post(`${process.env.REACT_APP_ENDPOINT}/api/Greenhouses/Move`, {
            sourceId: props.source?.id,
            destinationId: data.Bench.id,
            sourceType: props.sourceType
        })
    };


    const { register, handleSubmit, control, formState: { errors }, getValues, reset } = useForm<IFormInput>();
    return (
        <Box role="form">
            <Dialog open={props.isOpen} onClose={handleClose} maxWidth="lg" fullWidth>
                <DialogTitle>{props.title}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name="Greenhouse"
                                render={({ field: { ref, onChange, ...field } }) => (
                                    <Autocomplete
                                        options={greenhouses}
                                        getOptionLabel={(option) => `${option.name} - ${option.availableSpace}%`}
                                        onChange={(_, data) => {
                                            setGreenhouse(data!);
                                            return onChange(data);
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} {...field} fullWidth inputRef={ref} variant="filled" label="Greenhouses" sx={{ fontSize: '24px', fontWeight: '900' }}></TextField>
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name="Bay"
                                render={({ field: { ref, onChange, ...field } }) => (
                                    <Autocomplete
                                        options={bays}
                                        getOptionLabel={(option) => `${option.name} - ${option.availableSpace}%`}
                                        onChange={(_, data) => {
                                            setBay(data!);
                                            return onChange(data);
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} {...field} fullWidth inputRef={ref} variant="filled" label="Bays" sx={{ fontSize: '24px', fontWeight: '900' }}></TextField>
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name="Zone"
                                render={({ field: { ref, onChange, ...field } }) => (
                                    <Autocomplete
                                        options={zones}
                                        getOptionLabel={(option) => `${option.name} - ${option.availableSpace}%`}
                                        onChange={(_, data) => {
                                            setZone(data!);
                                            return onChange(data);
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} {...field} fullWidth inputRef={ref} variant="filled" label="Zones" sx={{ fontSize: '24px', fontWeight: '900' }}></TextField>
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name="Bench"
                                render={({ field: { ref, onChange, ...field } }) => (
                                    <Autocomplete
                                        options={benches}
                                        getOptionLabel={(option) => `${option.name} - ${option.availableSpace}%`}
                                        onChange={(_, data) => {
                                            setBench(data!);
                                            return onChange(data);
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} {...field} fullWidth inputRef={ref} variant="filled" label="Benches" sx={{ fontSize: '24px', fontWeight: '900' }}></TextField>
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' onClick={handleClose}>CANCEL</Button>
                    <Button variant='contained' onClick={handleSubmit(onSubmit)}>CONFIRM</Button>
                </DialogActions>
            </Dialog>
        </Box>

    )
}